import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class CheckinCheckoutService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerReporteVentasCheckResumen(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: checkin_checkoutInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            checkin_checkout {
              obtenerReporteVentasCheckResumen(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut_empresa
                    sucursal_codigo
                    codigo
                    nombre
                    cantidad_elementos
                    tiempo_max
                    tiempo_min
                    tiempo_prom
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            console.log('response', { response });
            const { mensajes, respuesta } = response.data.checkin_checkout.obtenerReporteVentasCheckResumen;
            callback({ mensajes, respuesta });
        });
    }
    obtenerReporteVentasCheckResumenExcel(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: checkin_checkoutInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            checkin_checkout {
              obtenerReporteVentasCheckResumen(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.checkin_checkout.obtenerReporteVentasCheckResumen;
            callback({ mensajes, respuesta });
        });
    }
    obtenerReporteVentasCheckDetalle(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: checkin_checkoutInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            checkin_checkout {
              obtenerReporteVentasCheckDetalle(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    numero_pedido
                    numero_nota_venta
                    numeros_factura
                    rut_empresa
                    sucursal_codigo
                    cliente_proveedor_rut
                    cliente_proveedor_nombre
                    direccion_codigo
                    direccion_nombre
                    nombrecomuna
                    codigo
                    nombre
                    tiempo
                    rango
                    hora_registro
                    hora_termino
                    fecha
                    motivo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.checkin_checkout.obtenerReporteVentasCheckDetalle;
            console.log('respuesta', { respuesta });
            callback({ mensajes, respuesta });
        });
    }
    obtenerReporteVentasCheckDetalleExcel(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: checkin_checkoutInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            checkin_checkout {
              obtenerReporteVentasCheckDetalle(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.checkin_checkout.obtenerReporteVentasCheckDetalle;
            callback({ mensajes, respuesta });
        });
    }
}
CheckinCheckoutService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CheckinCheckoutService_Factory() { return new CheckinCheckoutService(i0.ɵɵinject(i1.GraphQLClient)); }, token: CheckinCheckoutService, providedIn: "root" });
